export default "__VITE_ASSET__BkMf3Wt4__"